import { Marker, StreamEl, theme, TimeLabel } from '@mi-front/ui';
import { useTimezone } from '@app/core/hooks/useTimezone';
import { usePlaybackCurrentTs } from '../../../../../../../core/playback/hooks/usePlayback';

export function PlayheadP(p: { ts: number; tz?: string }) {
  return (
    <div data-testid="playhead">
      <Marker className="el-playhead" color={theme.green} ts={p.ts} />
      <StreamEl ts={p.ts} offsetY={-64} offsetX={6} position="bottom">
        <TimeLabel
          role={'playhead'}
          className="el-playhead-label"
          bgColor={theme.gray600}
          ts={p.ts}
          tz={p.tz}
          style={{
            pointerEvents: 'none',
          }}
        />
      </StreamEl>
    </div>
  );
}

export function Playhead() {
  const tz = useTimezone();
  const currentTs = usePlaybackCurrentTs();

  if (!currentTs) {
    return null;
  }

  return <PlayheadP ts={currentTs} tz={tz} />;
}
